'use strict';

const confirmationPopUp = require('../util/confirmationPopUp');
const appendToUrl = require('../util/appendToUrl');

module.exports = {
    makeFavoriteStore: () => {
        $('body').on('click', '.buttons__favourite', function () {
            var $this = $(this);
            let url = $('.store-detail').data('set-favorite-store-url');
            let urlParams = {
                storeID: $('.store-detail').data('store-id')
            };
            url = appendToUrl(url, urlParams);

            $.ajax({
                url: url,
                type: 'post',
                success: function () {
                    const favStoreUrl = $('.header-favorite-store').data('get-favorite-store-header-url');
                    const favStoreUrlMobile = $('.header-top__favorite-storeMobile').data('get-favorite-store-header-url');
                    $.ajax({
                        url: favStoreUrl,
                        type: 'get',
                        success: function (data) {
                            $('.header-top__favorite-store').html(data);
                            let favStordId = $(data).find('.store-details').data('store-id');
                            let storeId = parseInt(urlParams.storeID, 0);
                            let isFavorite = $('.store-detail').data('already-fav-store');
                            let notFavorite = $('.store-detail').data('not-fav-store');
                            if (favStordId === storeId) {
                                $this.attr('disabled', true);
                                $this.html(isFavorite);
                            } else {
                                $this.attr('disabled', false);
                                $this.html(notFavorite);
                            }
                        }
                    });
                    $.ajax({
                        url: favStoreUrlMobile,
                        type: 'get',
                        success: function (data) {
                            $('.header-top__favorite-storeMobile').html(data);
                        }
                    });
                },
                error: function () {
                    confirmationPopUp.show({
                        title: $('.store-detail').data('pop-up-error-title'),
                        message: $('.store-detail').data('pop-up-error-message'),
                        confirmButtonText: $('.store-detail').data('pop-up-button-text')
                    }, confirmationPopUp.TYPE_ERROR);
                }
            });
        });
    }
};
